import { useNavigate } from 'react-router-dom';
import { withTracking } from '@mindtickle/ui-shell-core/Mixpanel';

import useDropdownData from '../../../Shared/hooks/useDropdownData';
import { MixpanelEventNameType, MixpanelTrackType } from '../../type';
import ProfileMenuOption from '../../../Shared/components/ProfileMenuOption';
import ProfileDropdown from '../../../Shared/components/ProfileDropdown';
import { PROFILE_MENU_OPTIONS } from './config';
import { CompanyInfo, UserInfo, IntlType } from '~/components/GlobalHeader/Shared/type';

type ProfileProps = {
  company: CompanyInfo;
  user: UserInfo;
  track: MixpanelTrackType<MixpanelEventNameType>;
  logout: Function;
  intl: IntlType;
};

const Profile = ({ user, company, track, logout, intl }: ProfileProps) => {
  const navigate = useNavigate();
  const { isVisible, onHideDropdownContent, handleVisibilityChange } = useDropdownData();
  const actionConfig = {
    user,
    company,
    track,
    navigate,
    logout,
    onHideDropdownContent,
    intl,
  };

  return (
    <ProfileDropdown
      options={<ProfileMenuOption profileMenuOptions={PROFILE_MENU_OPTIONS(actionConfig)} />}
      user={user}
      intl={intl}
      isVisible={isVisible}
      handleVisibilityChange={handleVisibilityChange}
    />
  );
};

export default withTracking()(Profile);
